import { NavigateFunction } from 'react-router-dom';

export function scrollToStartHere(delay: number = 0) {
  const scroll = () => {
    const element = document.getElementById('start-here');
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.scrollY - navbarHeight - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  if (delay > 0) {
    setTimeout(scroll, delay);
  } else {
    scroll();
  }
}

export function navigateToStartHere(navigate: NavigateFunction, currentPath: string) {
  if (currentPath === '/') {
    scrollToStartHere();
  } else {
    navigate('/#start-here');
  }
}
